module.exports = __webpack_public_path__ + "img/coupon_nodata_img.9d2e7794.png";